import * as yup from 'yup';
import {
  acceptExtNamesFiles,
  maxFilesSize,
} from '@/components/GFileInput/helpers/validations';

import { nonEmptyFiles } from '@/shared/common/utils/fileValidation.util';

import { validateRut } from '@fdograph/rut-utilities';

yup.addMethod(
  yup.array,
  'acceptExtNames',
  function (acceptExtNames = [], message = '') {
    return this.test({
      name: 'acceptExtNames',
      exclusive: true,
      params: { acceptExtNames },
      message,
      test: function (value) {
        const { path, createError } = this;

        const { isValid, errorMessage } = acceptExtNamesFiles(
          value,
          acceptExtNames
        );

        return (
          isValid ||
          createError({
            path,
            message: message.length === 0 ? errorMessage : message,
            params: { ruleArgument: acceptExtNames },
          })
        );
      },
    });
  }
);

yup.addMethod(yup.array, 'maxFilesSize', function (size, message = '') {
  return this.test({
    name: 'maxFilesSize',
    exclusive: true,
    params: { maxFilesSize: size },
    message,
    test: function (value: File[] = []) {
      const { path, createError } = this;

      const { isValid, errorMessage } = maxFilesSize(value, size);

      return (
        isValid ||
        createError({
          path,
          message: message.length === 0 ? errorMessage : message,
          params: { ruleArgument: size },
        })
      );
    },
  });
});

yup.addMethod(yup.array, 'nonEmptyFiles', function (message = '') {
  return this.test({
    name: 'nonEmptyFiles',
    exclusive: true,
    message,
    test: function (value: File[] = []) {
      const { path, createError } = this;

      const { isValid, errorMessage } = nonEmptyFiles(value);

      return (
        isValid ||
        createError({
          path,
          message: message.length === 0 ? errorMessage : message,
        })
      );
    },
  });
});

yup.addMethod(yup.string, 'validateRutClp', function (message = '') {
  return this.test({
    name: 'validateRutClp',
    exclusive: true,
    message,
    test: function (value: string = '') {
      const { path, createError } = this;

      const isValid = validateRut(value || '');

      return (
        isValid ||
        createError({
          path,
          message:
            message.length === 0 ? 'El RUT ingresado no es válido' : message,
        })
      );
    },
  });
});

yup.addMethod(
  yup.string,
  'alphaNumeric',
  function (message = 'Este campo solo acepta caracteres alfanuméricos') {
    return this.matches(/^[0-9a-zA-Z]+$/, message);
  }
);

yup.addMethod(
  yup.string,
  'onlyStringNumber',
  function (message = 'Este campo solo acepta números') {
    return this.matches(/^\d+$/, message);
  }
);

export default yup;
